<template>
  <div class="cartItem fvlu" @click.stop>
    <div class="imgBox">
      <img :src="data.thumbnail" alt="图片缺失" />
    </div>
    <div class="orderIfnBox fhlud">
      <p class="planName ellipsis">{{ data?.productName || '暂无名称' }}</p>
      <p class="labelText">{{ data?.productNames || '暂无' }}</p>
      <p class="dealerName ellipsis">{{ data?.dealerInfo?.name }}</p>
      <p class="carText themeColor ellipsis">{{ (data.carInfo && data.carInfo.plate) || '' }} | {{ (data.carInfo && data.carInfo.model) || '' }}</p>
    </div>
  </div>
  <van-row class="ifnRow fvlru">
    <span>零售价</span>
    <span class="themeColor">￥{{ data.productPrice }}X{{ data.productAmount }}</span>
  </van-row>
  <van-row class="ifnRow fvlru">
    <span>优惠金额</span>
    <span class="themeRed">￥{{ data?.discounPrice }}</span>
  </van-row>
  <van-row class="ifnRow fvlru">
    <span>应付金额</span>
    <span class="themeColor">￥{{ data?.payPrice }}</span>
  </van-row>
  <van-row class="ifnRow fvlru">
    <van-field v-model="markText" label="备注" :placeholder="`您可以输入备注内容(${maxlength}字以内)`" :maxlength="maxlength" input-align="right" />
  </van-row>
</template>

<script>
import { reactive, toRefs, computed, watch } from 'vue'

export default {
  props: {
    data: {
      type: [Object, Array],
      default: () => []
    },
    priceWeight: {
      type: Boolean,
      default: false
    },
    hiddenPrice: {
      type: Boolean,
      default: false
    },
    sign: {
      type: String,
      default: ''
    }
  },
  components: {},
  emits: ['clickCard', 'clickImg', 'changeMark'],
  setup(props, { emit }) {
    let { data, priceWeight } = toRefs(props)
    const state = reactive({
      data: data.value,
      priceWeight: priceWeight.value,
      markText: data.value?.markText,
      maxlength: 20
    })
    const isArrayFn = value => {
      if (typeof Array.isArray === 'function') {
        return Array.isArray(value)
      } else {
        return Object.prototype.toString.call(value) === '[object Array]'
      }
    }
    watch(
      () => state.markText,
      v => {
        emit('changeMark', v)
      }
    )
    const productsData = computed(() => (isArrayFn(data.value) ? data.value : [data.value]))
    return {
      ...toRefs(state),
      productsData
    }
  }
}
</script>
<style lang="scss" scoped>
.imgBox,
.imgBox img {
  position: relative;
  display: inline-block;
  width: 99px;
  height: 74px;
  vertical-align: top;
}
.cartItem {
  width: 100%;
  font-size: 12px;
  color: #333;
}
.orderIfnBox {
  padding-left: 8px;
  width: calc(100% - 110px);
  height: 100%;
}
.planName {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
}
.carText {
  width: 100%;
  line-height: 16px;
}

.dealerName {
  width: 100%;
  color: #999;
}
.labelText {
  width: 100%;
  color: #666;
}
.ifnRow {
  padding: 12px 0 0;
  width: 100%;
  color: #222;
  line-height: 20px;
  font-size: 14px;
  :deep(.van-cell) {
    padding: 0;
  }
}

.priceNum {
  color: #666666;
}
.priceNum + .priceNum {
  margin-left: 16px;
  color: #666666;
}
.priceWeight {
  font-size: 16px;
  font-weight: 600;
  color: #3088c5;
}
</style>
